import Exchange from './src/pages/ShopSaga/Exchange';
import ExchangeUpdate from './src/pages/ShopSaga/Exchange/ExchangeUpdate';
import ExchangeCreate from './src/pages/ShopSaga/Exchange/ExchangeCreate';
import CurrencyOffer from './src/pages/ShopSaga/CurrencyOffer';
import CurrencyOfferUpdate from './src/pages/ShopSaga/CurrencyOffer/CurrencyOfferUpdate';
import CurrencyOfferCreate from './src/pages/ShopSaga/CurrencyOffer/CurrencyOfferCreate';
import ExclusiveOffer from './src/pages/ShopSaga/ExclusiveOffer';
import ExclusiveOfferUpdate from './src/pages/ShopSaga/ExclusiveOffer/ExclusiveOfferUpdate';
import ExclusiveOfferCreate from './src/pages/ShopSaga/ExclusiveOffer/ExclusiveOfferCreate';
import SpecialOffer from './src/pages/ShopSaga/SpecialOffer';
import SpecialOfferUpdate from './src/pages/ShopSaga/SpecialOffer/SpecialOfferUpdate';
import SpecialOfferCreate from './src/pages/ShopSaga/SpecialOffer/SpecialOfferCreate';
import TradeDeal from './src/pages/ShopSaga/TradeDeal';
import TradeDealUpdate from './src/pages/ShopSaga/TradeDeal/TradeDealUpdate';
import TradeDealCreate from './src/pages/ShopSaga/TradeDeal/TradeDealCreate';

const MenuShopSaga = [
    {
        id: 'currency-offer',
        name: 'CurrencyOffer',
        icon: 'icon-chemistry',
        path: 'currency-offer',
        component: CurrencyOffer,
        isShown: 1,
    },
    {
        path: 'currency-offer/create',
        name: 'CurrencyOffer > Create',
        component: CurrencyOfferCreate,
        isShown: 0,
    },
    {
        path: 'currency-offer/update/:id',
        name: 'CurrencyOffer > Update',
        component: CurrencyOfferUpdate,
        isShown: 0,
    },
    {
        id: 'exclusive-offer',
        name: 'ExclusiveOffer',
        icon: 'icon-chemistry',
        path: 'exclusive-offer',
        component: ExclusiveOffer,
        isShown: 1,
    },
    {
        path: 'exclusive-offer/create',
        name: 'ExclusiveOffer > Create',
        component: ExclusiveOfferCreate,
        isShown: 0,
    },
    {
        path: 'exclusive-offer/update/:id',
        name: 'ExclusiveOffer > Update',
        component: ExclusiveOfferUpdate,
        isShown: 0,
    },
    {
        id: 'special-offer',
        name: 'SpecialOffer',
        icon: 'icon-chemistry',
        path: 'special-offer',
        component: SpecialOffer,
        isShown: 1,
    },
    {
        path: 'special-offer/create',
        name: 'SpecialOffer > Create',
        component: SpecialOfferCreate,
        isShown: 0,
    },
    {
        path: 'special-offer/update/:id',
        name: 'SpecialOffer > Update',
        component: SpecialOfferUpdate,
        isShown: 0,
    },
    {
        id: 'trade-deal',
        name: 'TradeDeal',
        icon: 'icon-chemistry',
        path: 'trade-deal',
        component: TradeDeal,
        isShown: 1,
    },
    {
        path: 'trade-deal/create',
        name: 'TradeDeal > Create',
        component: TradeDealCreate,
        isShown: 0,
    },
    {
        path: 'trade-deal/update/:id',
        name: 'TradeDeal > Update',
        component: TradeDealUpdate,
        isShown: 0,
    },
];

export default MenuShopSaga;
